export default "__VITE_ASSET__DrrkGWja__"